import {
  FIELD_ERROR_TEXT_CLASS,
  FIELD_LABEL_CLASS,
  getErrorMessage,
  getFieldClass,
} from "./inputStyles";

const Input = ({
  className,
  defaultValue,
  error,
  label,
  name,
  value,
  required = false,
  type = "text",
  register,
  readOnly = false,
  disabled = false,
  ...props
}) => {
  const errorMessage = getErrorMessage(error);

  return (
    <div className={`w-full ${className || ""}`}>
      {label ? (
        <label className={FIELD_LABEL_CLASS} htmlFor={name}>
          {label}
        </label>
      ) : null}
      <input
        type={type}
        id={name}
        className={getFieldClass(Boolean(error))}
        {...(register && name ? register(name, { required }) : {})}
        value={value}
        defaultValue={defaultValue}
        readOnly={readOnly}
        disabled={disabled}
        {...props}
      />
      {errorMessage ? (
        <small className={FIELD_ERROR_TEXT_CLASS}>{errorMessage}</small>
      ) : null}
    </div>
  );
};

export default Input;
